import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=208f5146&scoped=true&"
import script from "./MerchantList.vue?vue&type=script&lang=js&"
export * from "./MerchantList.vue?vue&type=script&lang=js&"
import style0 from "./MerchantList.vue?vue&type=style&index=0&id=208f5146&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f5146",
  null
  
)

export default component.exports